import { colors } from '@10d/tend-ui-tokens/samolet';

import { IColor } from 'types';

export const ENGINEERING_STATUS_COLORS: IColor = {
  CALL: {
    color: colors.gray0,
    bgcColor: colors.blue600,
    name: 'На проверке',
  },
  IN_PROGRESS: {
    color: colors.gray0,
    bgcColor: colors.blue600,
    name: 'На проверке',
  },
  EXPLOITATION: {
    color: colors.gray0,
    bgcColor: colors.green600,
    name: 'Передана в эксплуатацию',
  },
  RE_CALL: {
    color: '#000000',
    bgcColor: colors.gray0,
    name: 'Повторный вызов',
  },
  NULL: {
    color: '#000000',
    bgcColor: colors.gray0,
    name: '',
  },
  NOT_READY: {
    color: colors.gray0,
    bgcColor: colors.gray400,
    name: 'Не готова к вызову',
  },
  ACCEPTED: {
    color: colors.gray0,
    bgcColor: colors.gold600,
    name: 'Готова к заселению',
  },
  READY_FOR_SETTLEMENT: {
    color: colors.gray0,
    bgcColor: colors.gold600,
    name: 'Готова к заселению',
  },
  NOT_ACCEPTED: {
    color: colors.gray0,
    bgcColor: colors.red600,
    name: 'Не принята',
  },
};
